import * as React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { compose } from 'recompose';
import { NotFoundPage, SomethingWentWrongPage } from '@soluto-home-web/platform-common-ui';
import { SHSApp } from '@soluto-home-web/smart-home-support';
import SwitchWithPerformance from './components/SwitchWithPerformance';
import RenderApp from './RenderApp';
import { enrichAnalytics } from 'react-shisell';
import withQueryParamAnalytics from './withQueryParamAnalytics';
import { flowId, homeUserId, messageId } from './queryParametersForAnalytics';

const App = () => (
  <Router>
    <SwitchWithPerformance>
      <Route path="/something-went-wrong" component={SomethingWentWrongPage} />
      <Route path="/" component={SHSApp} />
      <Route path="*" component={NotFoundPage} />
    </SwitchWithPerformance>
  </Router>
);

const CompositeApp = compose<{}, {}>(
  enrichAnalytics((dispatcher) => dispatcher.createScoped('SHS')),
  withQueryParamAnalytics(flowId, homeUserId, messageId)
)(App);

RenderApp(CompositeApp);



// WEBPACK FOOTER //
// ./packages/web-app/src/App.tsx